"use client";

// packages/eden-table/src/components/TFoot.jsx
import styled from "styled-components";
import {
  borderColorPrimary,
  fontWeightBold
} from "@churchofjesuschrist/eden-style-constants";
import TableSectionContext from './Table/TableSectionContext.js';
import { jsx } from "react/jsx-runtime";
var Root = styled.tfoot`
  font-weight: ${fontWeightBold};
  border-block-start: 2px solid ${borderColorPrimary};

  th {
    position: static;
  }
`;
var TFoot = ({ children, ...props }) => /* @__PURE__ */ jsx(Root, { ...props, children: /* @__PURE__ */ jsx(TableSectionContext.Provider, { value: "tfoot", children }) });
TFoot.displayName = "TFoot";
var TFoot_default = TFoot;
export {
  TFoot_default as default
};
